export default __webpack_public_path__ + "static/media/remarkable_dark_logo.745897d6.svg";